// <head> страницы «Для репетиторов и кружков»: мета на языке страницы,
// canonical, hreflang, шрифты и стили. Скрипт Google Maps здесь НЕ
// подключается — его грузит PinPicker, только когда форма на экране.
import tjCss from "./tutor-join.css?url";
// Карточка карты (tutors-map.css) — для предпросмотра «Так вас увидят родители».
import tmCss from "./tutors-map.css?url";
import { PARTNER_COPY, TUTORS_JOIN_PATH } from "./partner-copy";
import type { SiteLang } from "@/components/site/SiteChrome";
import { SITE_CHROME_LINKS } from "@/components/site/site-chrome-head";
import { OG_LOCALE, ogImageMeta, socialMeta } from "@/lib/page-meta";

const SITE = "https://yolutap.com";

// ПРЕВЬЮ В МЕССЕНДЖЕРАХ (13.10). Было фото мальчика из __root и маленькая
// карточка. Теперь своя JPG 1200×630 на языке страницы — тем же хелпером,
// что у подбора. alt — заголовок карточки.
// 25.10: картинка из src/lib/tutor-join-og-card.ts (карта без районов Баку);
// ?v=2 — чтобы мессенджеры не показывали закэшированную старую.
export const TUTOR_JOIN_OG_IMAGE: Record<SiteLang, { url: string; alt: string }> = {
  az: { url: `${SITE}/og/tutors-join-az.jpg?v=2`, alt: "Şagirdlər səni xəritədə tapsın" },
  ru: { url: `${SITE}/og/tutors-join-ru.jpg?v=2`, alt: "Пусть ученики найдут вас на карте" },
  en: { url: `${SITE}/og/tutors-join-en.jpg?v=2`, alt: "Let students find you on the map" },
};

export function tutorJoinHead(lang: SiteLang) {
  const url = SITE + TUTORS_JOIN_PATH[lang];
  return {
    meta: [
      ...socialMeta(PARTNER_COPY[lang].meta),
      ...ogImageMeta(TUTOR_JOIN_OG_IMAGE[lang].url, TUTOR_JOIN_OG_IMAGE[lang].alt),
      { property: "og:type", content: "website" },
      { property: "og:url", content: url },
      { property: "og:locale", content: OG_LOCALE[lang] },
    ],
    links: [
      { rel: "canonical", href: url },
      { rel: "alternate", hrefLang: "ru", href: SITE + TUTORS_JOIN_PATH.ru },
      { rel: "alternate", hrefLang: "az", href: SITE + TUTORS_JOIN_PATH.az },
      { rel: "alternate", hrefLang: "en", href: SITE + TUTORS_JOIN_PATH.en },
      // x-default — азербайджанская версия (27.10.2026, решение владельца: x-default везде = /az).
      { rel: "alternate", hrefLang: "x-default", href: SITE + TUTORS_JOIN_PATH.az },
      ...SITE_CHROME_LINKS,
      { rel: "stylesheet", href: tjCss },
      { rel: "stylesheet", href: tmCss },
    ],
  };
}
